import React, { useState } from 'react';
import emailService from '../services/emailService';
import notificationService from '../services/notificationService';
import './ScholarshipForm.css';

const ScholarshipForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    email: '',
    studyLevel: '',
    destination: '',
    academicLevel: '',
    passingYear: '',
    result: '',
    englishProficiency: '',
    overallScore: '',
    privacyPolicy: false
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validate form data
    const validation = emailService.validateScholarshipForm(formData);
    if (!validation.isValid) {
      validation.errors.forEach(error => {
        notificationService.error('Validation Error', error);
      });
      return;
    }

    setIsSubmitting(true);
    const loadingId = notificationService.loading('Submitting', 'Please wait while we process your scholarship application...');

    try {
      const result = await emailService.sendScholarshipForm(formData);
      
      notificationService.removeNotification(loadingId);
      
      if (result.success) {
        notificationService.success('Application Submitted!', result.message);
        // Reset form
        setFormData({
          name: '',
          mobile: '',
          email: '',
          studyLevel: '',
          destination: '',
          academicLevel: '',
          passingYear: '',
          result: '',
          englishProficiency: '',
          overallScore: '',
          privacyPolicy: false
        });
      } else {
        notificationService.error('Submission Failed', result.message);
      }
    } catch (error) {
      notificationService.removeNotification(loadingId);
      notificationService.error('Submission Failed', 'An unexpected error occurred. Please try again.');
      console.error('Form submission error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="scholarship-form section">
      <div className="container">
        <div className="form-container">
          <div className="form-header">
            <div className="header-icon">
              <i className="fas fa-pen-fancy"></i>
            </div>
            <div className="header-text">
              <p>Fill up the following form to get assessed for up</p>
              <span className="scholarship-percentage">70%</span>
              <p>scholarship.</p>
            </div>
          </div>

          <form onSubmit={handleSubmit} className="scholarship-form-content">
            <div className="form-row">
              <div className="form-field full-width">
                <div className="field-icon">
                  <i className="fas fa-user"></i>
                </div>
                <input
                  type="text"
                  name="name"
                  placeholder="Enter your name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-field">
                <div className="field-icon">
                  <i className="fas fa-phone"></i>
                </div>
                <input
                  type="tel"
                  name="mobile"
                  placeholder="Mobile number"
                  value={formData.mobile}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-field">
                <div className="field-icon">
                  <i className="fas fa-envelope"></i>
                </div>
                <input
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-field">
                <div className="field-icon">
                  <i className="fas fa-graduation-cap"></i>
                </div>
                <select
                  name="studyLevel"
                  value={formData.studyLevel}
                  onChange={handleChange}
                  required
                >
                  <option value="">Interested level of study</option>
                  <option value="undergraduate">Undergraduate</option>
                  <option value="graduate">Graduate</option>
                  <option value="phd">PhD</option>
                </select>
              </div>
              <div className="form-field">
                <div className="field-icon">
                  <i className="fas fa-globe"></i>
                </div>
                <select
                  name="destination"
                  value={formData.destination}
                  onChange={handleChange}
                  required
                >
                  <option value="">Study destination</option>
                  <option value="canada">Canada</option>
                  <option value="usa">USA</option>
                  <option value="uk">UK</option>
                  <option value="australia">Australia</option>
                </select>
              </div>
            </div>

            <div className="academic-result-section">
              <div className="section-label">Latest Academic Result</div>
              <div className="form-row">
                <div className="form-field">
                  <div className="field-icon">
                    <i className="fas fa-book"></i>
                  </div>
                  <select
                    name="academicLevel"
                    value={formData.academicLevel}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Level of Study</option>
                    <option value="hsc">HSC</option>
                    <option value="bachelor">Bachelor</option>
                    <option value="master">Master</option>
                  </select>
                </div>
                <div className="form-field">
                  <div className="field-icon">
                    <i className="fas fa-calendar"></i>
                  </div>
                  <input
                    type="text"
                    name="passingYear"
                    placeholder="Passing Year"
                    value={formData.passingYear}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-field">
                  <div className="field-icon">
                    <i className="fas fa-star"></i>
                  </div>
                  <input
                    type="text"
                    name="result"
                    placeholder="Result"
                    value={formData.result}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
            </div>

            <div className="form-row">
              <div className="form-field">
                <div className="field-icon">
                  <i className="fas fa-language"></i>
                </div>
                <select
                  name="englishProficiency"
                  value={formData.englishProficiency}
                  onChange={handleChange}
                  required
                >
                  <option value="">English proficiency</option>
                  <option value="ielts">IELTS</option>
                  <option value="toefl">TOEFL</option>
                  <option value="pte">PTE</option>
                </select>
              </div>
              <div className="form-field">
                <div className="field-icon">
                  <i className="fas fa-chart-line"></i>
                </div>
                <input
                  type="text"
                  name="overallScore"
                  placeholder="Overall Score"
                  value={formData.overallScore}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="privacy-policy">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  name="privacyPolicy"
                  checked={formData.privacyPolicy}
                  onChange={handleChange}
                  required
                />
                <span className="checkmark"></span>
                By clicking you agree to our Privacy Policy*
              </label>
            </div>

            <button type="submit" className="submit-btn" disabled={isSubmitting}>
              {isSubmitting ? 'Submitting...' : 'Submit now'}
              <div className="submit-icon">
                <i className={isSubmitting ? 'fas fa-spinner fa-spin' : 'fas fa-arrow-right'}></i>
              </div>
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ScholarshipForm;
